import { ApiResponse, ProfileAdditionalDataNoId, ProfileAdditionalData, User } from "@bonusmap/api-types";
import { templateParseToElement } from "../../logic/templateParse.js";
import { StepsComponent } from "../base-components/steps-component.js";
import { showConfirm } from "../../modals.js";
import { FormComponent } from "../form-component/form-component.js";
import { isNumber } from "@bonusmap/shared_ui/library";
import { createChoicesInstance } from "../../utils/createChoicesInstance.js";
const { Choices } = window;

export class ProfileAdditionalDataComponentInput extends StepsComponent {
    static webComponentName: string = "profile-additional-data-input";
    static observedAttributes = ['data-attribute'];
    protected _templateId: string = "profile-additional-data-input";
    protected _step: string = 'additionals-view'; // Default step is the list of attributes
    private additionalDataView!: HTMLElement;
    private addAdditionalBtn!: HTMLButtonElement;
    private editAdditionalBtn!: HTMLButtonElement;
    private removeAdditionalBtn!: HTMLButtonElement;
    private listSelect!: HTMLSelectElement;
    // private additionalForm!: HTMLFormElement;
    private additionalForm!: FormComponent;
    private choicesInstance!: InstanceType<Window['Choices']>; // Choice.js instance
    private _value: string = "";
    private dataCache: Record<number, ProfileAdditionalData> = {}; // Cache degli oggetti scaricati dal server
    get readOnly(): boolean {
        return this.hasAttribute('readonly') || this.hasAttribute('disabled');
    }
    get compact(): boolean {
        return this.hasAttribute('compact');
    }
    get value(): string {
        return this._value;
    }
    private set value(newValue: string) {
        if (newValue && !isNumber(newValue)) {
            return; // Prevent setting non-numeric values
        }
        this._value = newValue;
        this.valueChanged(newValue);
       
        this.setAttribute('value', newValue.toString());
    }
    get current(): ProfileAdditionalData | null {
        if (!this.value || !isNumber(this.value)) {
            return null; // No valid value set
        }
        const cached = this.getCached(this.value);
        if (cached) {
            return cached; // Return from cache if available
        }
        return null;
    }


    protected valueChanged(newValue: string): void {
        // Dispatch event to notify of value change
        this.dispatch('value-changed', {
            value: newValue
        });
        if (this.editAdditionalBtn && this.current) {
            this.editAdditionalBtn.classList.toggle('d-none', !newValue ||
                (this.current.organization_id==0 && !this.isAdmin));
        }
        if (this.removeAdditionalBtn && this.current) {
            this.removeAdditionalBtn.classList.toggle('d-none', !newValue ||
                (this.current.organization_id==0 && !this.isAdmin));
        }
        if (this.addAdditionalBtn) {
            this.addAdditionalBtn.classList.toggle('d-none', !!newValue);
        }
        if (newValue == "") {
            this.editAdditionalBtn?.classList.add('d-none');
            this.removeAdditionalBtn?.classList.add('d-none');
            this.addAdditionalBtn?.classList.remove('d-none');
           
        }
        else {
           
        }
    }
    constructor() {
        super();
        this.globalEventListeners();
    }
    protected renderForm(action: 'add' | 'edit'): void {
        if (action === 'add') {
            if (this.additionalForm) {
                this.additionalForm.dataset.action = 'add'; // Set action to add
            }
            this.clearForm(); // Clear the form when entering the attributes form step
        }
        else if (action === 'edit') {
            if (!this.current) {
                console.warn('Nessun dato selezionato per la modifica');
                return;
            }
            this.clearForm();
            if (this.current && this.additionalForm) {
                this.additionalForm.dataset.action = 'edit';
                this.roleElementSelector('additionals-form-title')!.textContent = 'Modifica dato'; //  titolo del form
                // Pre-populate the form with the current attribute data
                const idInput = this.additionalForm.querySelector('[name="id"]') as HTMLInputElement;
                const nameInput = this.additionalForm.querySelector('[name="name"]') as HTMLInputElement;
                const labelInput = this.additionalForm.querySelector('[name="label"]') as HTMLInputElement;
                const descriptionTextarea = this.additionalForm.querySelector('[name="description"]') as HTMLTextAreaElement;
                const organizationInput = this.additionalForm.querySelector('[name="organization_id"]') as HTMLInputElement | HTMLSelectElement;
                if (idInput) idInput.value = this.current.id.toString();
                if (nameInput) nameInput.value = this.current.name || '';
                if (labelInput) labelInput.value = this.current.label || '';
                if (descriptionTextarea) descriptionTextarea.value = this.current.description || '';
                if (organizationInput) {
                    if (organizationInput.tagName === 'SELECT') {
                        (organizationInput as HTMLSelectElement).value = this.current.organization_id?.toString() || '0';
                    } else {
                        (organizationInput as HTMLInputElement).value = this.current.organization_id?.toString() || '';
                    }
                    organizationInput.disabled = true; // Disable organization selection for editing
                }
            }
        }
    }
    private globalEventListeners(): void {
        this.addEventListener('before-step-changed', (event: Event) => {
            const { step, target } = (event as CustomEvent).detail;
            if (step === 'additionals-form') {
                if (target === this.addAdditionalBtn) {
                    this.renderForm('add');
                }
                else if (target === this.editAdditionalBtn) {
                    this.renderForm('edit');
                    
                }
            }
        });
        this.addEventListener('step-changed', (event: Event) => {
            const { step, target } = (event as CustomEvent).detail;
            event.stopPropagation(); // Prevent event from bubbling up
            // [debug] console.log(`Step changed to ${step}`, target);
            this.dispatch('profile-additional-data-step', { step });
        });
        this.addEventListener('value-changed', (event: Event) => {
            this.renderProcessView(); // Render the current attribute view
        });
        this.on('input', 'input[name="name"]', function (event: Event) {
            // consentito solo a-z 0-9 _ 
            const input = event.target as HTMLInputElement;
            input.value = input.value.replace(/[^a-z0-9_]/g, '');
         })
         this.dispatch('profile-additional-data-step', { step:this.step });
    }

    private processAttributeValue(): void {
        const attributeValue = this.getAttribute('value');
        if (!attributeValue) {
            console.warn('Nessun ID dato specificato, non posso processare il valore');
            return;
        }
      
        this.addItemToChoicesById(attributeValue)
            .then(() => {
                this.value = attributeValue; // Set the value after adding to choices
            })
    }
    private getCached(id: number | string): ProfileAdditionalData | null {
        if (!id || !isNumber(id as string)) {
            console.warn('ID dato non specificato, non posso cercare nella cache');
            return null;
        }
        const numId = parseInt(id as string, 10);
        return this.dataCache[numId] || null;
    }

    private async getAttributeById(id: number | string): Promise<ProfileAdditionalData | null> {
        try {
            const response = await window.api.manager.profilesAdditionalData.getById(parseInt(id as string, 10));
            if (response.success) {
                return response.data as ProfileAdditionalData;
            } else {
                console.error('Error fetching attribute by ID:', response.error);
                return null;
            }
        } catch (error) {
            console.error('Error in getAttributeById:', error);
            return null;
        }
    }
    protected renderProcessView(): void {
        const item = this.current;
        if (!this.additionalDataView) {
            this.additionalDataView = this.roleElementSelector('additionals-view') as HTMLElement;
        }
        if (!this.additionalDataView) {
            console.warn('Elemento additionals-view non trovato, impossibile renderizzare la vista');
            return;
        }
        this.additionalDataView.innerHTML = ''; // Clear previous content

        let data = {
            readOnly: this.readOnly,
            compact: this.compact
        };
        if (item) {
            data = {
                ...data,
                ...item
            }
        }
        templateParseToElement(
            `profile-additional-data-component-view${this.compact ? '-compact' : ''}`,
            this.additionalDataView,
            data);


    }
    private async addItemToChoicesById(id: number | string): Promise<boolean> {
        const item = await this.getAttributeById(id);
        if (!item) {
            return false;
        }

        // Aggiungo l'dato alla cache
        this.dataCache[item.id] = item;

        const choice = {
            value: item.id.toString(),
            label: item.label,
            selected: true,
            customProperties: item
        };

        this.choicesInstance.setChoices([choice], 'value', 'label', false);
        return true;
    }
    private async performSearch(searchTerm: string): Promise<void> {
        if (!searchTerm || searchTerm.length == 0) {
            this.choicesInstance.clearChoices();
            // return; <- commentata per permettere ricerca senza termine
        }
        try {
            let whereClause = searchTerm && searchTerm.length > 0
                ? `label ILIKE $1 OR description ILIKE $1`
                : `1=1`; // Cerca tutti gli elementi se non c'è termine di ricerca
            let paramDefSchema = searchTerm && searchTerm.length > 0
                ? [`%${searchTerm}%`]
                : [];
            const orderBy = 'label ASC';
            const limit = 20; // Limit results to 20 for performance
            const result = await window.api.manager.profilesAdditionalData.query(whereClause, paramDefSchema, orderBy, limit);
            if (result.data && result.data.length > 0) {
                // Aggiungo tutti i nuovi oggetti alla cache
                result.data.forEach((item: ProfileAdditionalData) => {
                    this.dataCache[item.id] = item;
                });

                const choices = result.data.map((item: ProfileAdditionalData) => {
                    return {
                        value: item.id.toString(),
                        label: item.label,
                        customProperties: item
                    };
                });
                this.choicesInstance.setChoices(choices, 'value', 'label', true);
            }
            else {
                this.choicesInstance.clearChoices();
            }
        } catch (error) {
            console.error('Error during search:', error);
            this.choicesInstance.clearChoices();
            return;

        }
    }
    private initializeChoices(): void {
        this.choicesInstance = createChoicesInstance(this.listSelect, {
            searchEnabled: true,
            removeItemButton: true,
            noResultsText: 'Nessun dato trovato',
            searchPlaceholderValue: 'Digita per cercare attributi...',
            maxItemCount: 20,
            // Personalizzazione template items nei risultati di ricerca
            callbackOnCreateTemplates: (template) => {
                return {
                    choice: (classNames, choice, selectText, groupName) => {
                        return this.createCustomChoiceTemplate(template, classNames, choice, selectText, groupName);
                    }
                };
            }
        });
        
        this.listSelect.addEventListener('search', (event: any) => {
            const searchTerm = event.detail.value;
            // if (searchTerm && searchTerm.length >= 1) {
            // consente l'avvio anche se il termine è vuoto
            this.performSearch(searchTerm);
            // }
        });
        this.listSelect.addEventListener('addItem', (event: any) => {
            const id = event.detail.value;
            const cached = this.getCached(id);
            if (cached) {
                this.value = cached.id.toString(); // Set the value to the ID of the added attribute
            }

        });
        this.listSelect.addEventListener('removeItem', (event: any) => {
            this.value = ''; // Clear the value when an item is removed
        });

        // Carica i dati iniziali al focus se il dropdown è vuoto
        this.listSelect.addEventListener('showDropdown', (event: any) => {
            const currentSearchTerm = this.choicesInstance.input?.value || '';
            this.performSearch(currentSearchTerm);
        });
    }

    /**
     * Crea un template personalizzato per gli items nei risultati di ricerca
     * Utilizza templateParseToElement per renderizzare il template Nunjucks
     */
    private createCustomChoiceTemplate(template: any, classNames: any, choice: any, selectText: string, groupName?: string): HTMLDivElement {
        // choice è un oggetto ChoiceFull di Choices.js
        // I miei dati da performSearch sono in choice.customProperties
        const templateData = {
            // Dati di base da Choices.js (ChoiceFull interface)
            id: choice.id,
            value: choice.value,
            label: choice.label,
            selectText: selectText,
            group: choice.group,
            disabled: choice.disabled,

            // I miei dati sono in customProperties (da performSearch:28-37)
            customProperties: choice.customProperties || {},
        };
        // Uso templateParseToElement per renderizzare il template
        const customDiv = document.createElement('div');
        templateParseToElement('profile-additional-data-component-item-search', customDiv, templateData);

        if (!customDiv.hasChildNodes()) {
            // Fallback al template di default di Choices.js se il nostro template non funziona
            console.warn('Template personalizzato non trovato, uso il default di Choices.js');
            return template.choice(classNames, choice, selectText, groupName);
        }


        // Aggiungo le classi CSS richieste da Choices.js
        const { item, itemChoice, itemSelectable, selectedState, itemDisabled, placeholder } = classNames.classNames;

        customDiv.classList.add(...item, ...itemChoice);
        customDiv.id = choice.elementId;

        // Gestione stati Choices.js
        if (choice.selected) {
            customDiv.classList.add(...selectedState);
        }

        if (choice.placeholder) {
            customDiv.classList.add(...placeholder);
        }

        if (choice.disabled) {
            customDiv.classList.add(...itemDisabled);
        } else {
            customDiv.classList.add(...itemSelectable);
        }

        return customDiv;
    }
    protected buildRenderingData(): Record<string, any> {
        const user = this.user;
        let organization_id = user.organization_id || 0; // Default to 0 if not set
        let organizations: any[] = [];
        if (user.impersonation) {
            organizations = [
                {
                    id: user.organization_id,
                    name: user.organization_name || 'Organizzazione Originale'
                },
                {
                    id: user.impersonation.id,
                    name: user.impersonation.name || 'Organizzazione Impersonata'
                }
            ]
        }
        const data = {
            organization_id,
            organization_name: user.organization_name || '',
            role: user.role,
            isAdmin: this.isAdmin,
            isEdit: this.isEdit,
            is_core: organization_id === 0, // se organization_id è 0
        };
        return data;
    }
   

    private formSubmitHandler(event: Event): void {
        event.preventDefault();
        if (this.additionalForm.checkValidity() === false) {
            console.warn('Form non valido, verifica i campi richiesti');
            this.additionalForm.reportValidity();
            return;
        }
        const data = this.getFormData();
        const action = this.additionalForm.dataset.action || 'add';
        if (action !== 'add' && action !== 'edit') {
            console.error('Azione del form non valida:', action);
            return;
        }
        const { name, description = "" , label} = data;
        const { organization_id } = data;
        let payload: ProfileAdditionalDataNoId | ProfileAdditionalData = {
            name,
            label: label || name,
            description,
            organization_id: parseInt(organization_id, 10) || 0, // Default to 0 if not set
        }
        try {
            if (action === 'edit') {
                const id = parseInt(data.id, 10);
                if (!isNumber(id)) {
                    console.error('ID non valido per l\'azione di modifica');
                    return;
                }
                (payload as ProfileAdditionalData).id = id; // Aggiungo l'ID per l'azione di modifica
            }
            const method = action === 'add' ? 'add' : 'update';
            window.api.manager.profilesAdditionalData
            [method]((payload as any))
                .then((result: ApiResponse<{ id: number }>) => {
                    if (!result.success) {
                        // [debug] console.log('payload:', payload);
                        console.error(result.error);
                        return;
                    }
                    else {
                        // [debug] console.log('Azione completata con successo:', result.data);
                        const id = result.data?.id;
                        if (id) {
                            this.addItemToChoicesById(id);
                        }
                        this.afterSave();                        
                    }

                });
        } catch (error) {

        }
    }
    protected afterSave () : void {
        this.step = 'additionals-list'; // Torno alla lista dopo l'aggiunta
    }
    private removeCurrentAttribute(): void {
        if (!this.current) {
            return;
        }
        showConfirm("Sei sicuro di voler rimuovere questo dato?", {
        })
            .then((confirmed) => {
                if (!confirmed || !this.current?.id) {
                    return;
                }
                window.api.manager.profilesAdditionalData.delete(this.current.id)
                    .then((result: ApiResponse<ProfileAdditionalData | null>) => {
                        if (result.success) {
                            this.value = ''; // Reset the value after removal
                            this.choicesInstance.removeActiveItems(); // Remove the item from Choices.js
                            this.choicesInstance.clearChoices();
                        } else {
                            console.error('Errore durante la rimozione dell\'dato:', result.error);
                        }
                    });
            });
    }
    private getFormData(): Record<string, any> {
        const data: Record<string, any> = this.additionalForm.getFormData();

        // FormData ignora i campi disabled, li aggiungo manualmente
        const allInputs = this.additionalForm.querySelectorAll('input, select, textarea');
        allInputs.forEach((input: Element) => {
            if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement) {
                if (input.name && input.disabled) {
                    data[input.name] = input.value;
                }
            }
        });
        data['organization_id'] = data['organization_id'] ? parseInt(data['organization_id'] as string, 10) : 999;
        return data;
    }

    private clearForm(): void {
        if (!this.additionalForm) {
            console.warn('Form attributes non trovata, impossibile svuotarla');
            return;
        }

        // Reset di tutti i campi del form
        this.additionalForm.reset();
        // riabilito i campi disabilitati
        const inputs = this.additionalForm.querySelectorAll('input, select, textarea');
        inputs.forEach((input: Element) => {
            if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement) {
                input.disabled = false; // Riabilito i campi
            }
        });
        this.roleElementSelector('additionals-form-title')!.textContent = 'Aggiungi Nuovo dato'; // Reset del titolo del form
    }

    protected afterRender(): void {
        super.afterRender();
        // Inizializzo i componenti specifici di questo web component
        // this.panelList = this.roleElementSelector('additionals-list') as HTMLDivElement;
        this.additionalDataView = this.roleElementSelector('additionals-view') as HTMLElement;
        this.listSelect = this.roleElementSelector('additionals-select') as HTMLSelectElement;
        this.editAdditionalBtn = this.roleElementSelector('edit-additional-btn') as HTMLButtonElement;
        this.addAdditionalBtn = this.roleElementSelector('add-additional-btn') as HTMLButtonElement;
        this.removeAdditionalBtn = this.roleElementSelector('remove-additional-btn') as HTMLButtonElement;
        this.initializeChoices();

        this.removeAdditionalBtn.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();
            this.removeCurrentAttribute();
        });
        this.additionalForm = this.roleElementSelector('additionals-form') as FormComponent;
        this.processAttributeValue(); // Process the initial attribute value if set
        this.renderProcessView();
        setTimeout(() => {
            
            this.additionalForm.addEventListener('submit', this.formSubmitHandler.bind(this));
        }, 500); // Use setTimeout to ensure it runs after the DOM is updated
    }
    protected render(): void {
        const user = this.user;
        if (!user) {
            this.onRenderError('User not found');
            return; // Prevent rendering if user is not available
        }
        super.render();
    }

}